import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { VariableSizeList as List } from 'react-window'
import classnames from 'classnames/bind'
import { CARD_HEIGHT, ESTIMATED_ASSET_ROW_HEIGHT, GAP } from './constants'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const getItemSize = (index, rows) => {
  if (rows[index]?.height) {
    return rows[index].height
  } else {
    return CARD_HEIGHT + GAP
  }
}

export const DynamicSizeList = ({
  listRef,
  itemsPerRow,
  onRowSizeUpdated,
  rows,
  width,
  height,
  elmId,
}) => {
  useEffect(() => {
    onRowSizeUpdated(itemsPerRow)
  }, [itemsPerRow, onRowSizeUpdated])

  return (
    <List
      ref={listRef}
      data-elm-id='list-data-elm'
      className={cx('list')}
      height={height}
      itemCount={rows.length}
      estimatedItemSize={ESTIMATED_ASSET_ROW_HEIGHT}
      itemSize={index => getItemSize(index, rows)}
      width={width}
    >
      {listChildProps => {
        const rowComponent = rows[listChildProps.index].rowComponent

        return (
          <div
            className={cx(`${elmId}-row`)}
            key={`asset_row_${listChildProps.index}`}
            style={{ ...listChildProps.style, pointerEvents: 'auto' }}
          >
            {rowComponent}
          </div>
        )
      }}
    </List>
  )
}

DynamicSizeList.propTypes = {
  listRef: PropTypes.object,
  itemsPerRow: PropTypes.number,
  onRowSizeUpdated: PropTypes.func,
  rows: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  elmId: PropTypes.string,
}

export const scrollToTop = () => {
  if (window) window.scrollTo(0, 0)
}
